/**
 * What one work asks of the curved wall beyond its film, by catalogue slug. The template sizes
 * itself from any film; these are the few choices a film cannot make for itself. They live here
 * until the catalogue's Room tab can carry them.
 */
export interface WallLook {
  /** Above 1, a tighter curve: the wall keeps its size and wraps further round the viewer. */
  bend?: number;
  /** False where the film has a frame of its own: the wall goes without its hairlines of light. */
  edges?: boolean;
}

export const WALL_LOOKS: Record<string, WallLook> = {
  // A miniature painting in its own gilt border, shown as one deep sweep around the visitor.
  'muraqqa-reality': { bend: 1.35, edges: false },
};
